import { render, staticRenderFns } from "./AreaLocation.vue?vue&type=template&id=398f2b00&scoped=true"
import script from "./AreaLocation.vue?vue&type=script&lang=js"
export * from "./AreaLocation.vue?vue&type=script&lang=js"
import style0 from "./AreaLocation.vue?vue&type=style&index=0&id=398f2b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f2b00",
  null
  
)

export default component.exports